import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import api from "./api";
import BootstrapVue from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueInsProgressBar from "vue-ins-progress-bar";
import "./Filter";
import "@/assets/main.css";
import device from "current-device";
//import Auth
import Auth from "./Auth.js";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

//import css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

//font awesome
import fontawesome from "@fortawesome/fontawesome";
import FontAwesomeIcon from "@fortawesome/vue-fontawesome";
import solid from "@fortawesome/fontawesome-free-solid";

// Datepicker
import "vue-datetime/dist/vue-datetime.css";

import VueAnalytics from "vue-analytics";
import AutoLogout from "./AutoLogout.vue";
import VueLoading from "vuejs-loading-plugin";
import VueSpinners from "vue-spinners";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueQrcodeReader from "vue-qrcode-reader";

// Vue.use(AxiosPlugin);
Vue.use(VueAnalytics, {
  id: "UA-61081515-1",
  router,
});
Vue.use(VueInsProgressBar, options);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("auto-logout", AutoLogout);
Vue.component(VueQrcode.name, VueQrcode);

Vue.use(BootstrapVue);
Vue.use(api);
Vue.use(VueAxios, axios);
Vue.use(Auth);
Vue.use(VueLoading);
Vue.use(VueSpinners);
Vue.use(VueQrcodeReader);
Vue.use(Toast, { timeout: 3000 });

router.beforeEach(function (to, from, next) {
  var isLoggedIn = Vue.auth.loggedIn();

  var requiresAuth = (record) => record.meta.requiresAuth;

  if (to.matched.some(requiresAuth) && !isLoggedIn) {
    next({
      path: "/login",
    });
  } else {
    next();
  }
});

fontawesome.library.add(solid);
Vue.prototype.globalError = false;
Vue.prototype.globalErrorMessage = "Алдаа гарлаа";

const options = {
  position: "fixed",
  show: true,
  height: "4px",
};

Vue.config.productionTip = true;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#nomin-bonus-card");
